import { render, staticRenderFns } from "./ModalPatientCases.vue?vue&type=template&id=264bed3e&scoped=true&"
import script from "./ModalPatientCases.vue?vue&type=script&lang=js&"
export * from "./ModalPatientCases.vue?vue&type=script&lang=js&"
import style0 from "./ModalPatientCases.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalPatientCases.vue?vue&type=style&index=1&id=264bed3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264bed3e",
  null
  
)

export default component.exports